import {createAction} from "redux-act";
import {ISnapshot} from "../../reducers/tipping_stats";

export const fetchSnapshot = createAction("Fetch Snapshot");
export const clearSnapshot = createAction("Fetch Snapshot");
export const fetchSnapshotSuccess = createAction<ISnapshot>(
	"Fetch SnapshotSuccess"
);
